import { render } from "./KnowledgeCourseDisplay.vue?vue&type=template&id=062faaa6&scoped=true"
import script from "./KnowledgeCourseDisplay.vue?vue&type=script&lang=js"
export * from "./KnowledgeCourseDisplay.vue?vue&type=script&lang=js"

import "./KnowledgeCourseDisplay.vue?vue&type=style&index=0&id=062faaa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062faaa6"]])

export default __exports__